import React from "react";

import { Avatar, CardHeader } from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  info: { flex: 1, minWidth: 0, padding: "8px 12px",
    "& .MuiCardHeader-content": { minWidth: 0 },
    "& .MuiCardHeader-subheader": { color: theme.palette.primary.main, fontWeight: 500 },
    [theme.breakpoints.down("sm")]: { padding: "6px 4px",
      "& .MuiCardHeader-avatar": { marginRight: 6 },
      "& .MuiAvatar-root": { width: 30, height: 30 },
      "& .MuiCardHeader-title": { fontSize: 13, fontWeight: 600 },
      "& .MuiCardHeader-subheader": { fontSize: 11 },
      "& .assignedOperator": { display: "none" }
    }
  }
}));

import { i18n } from "../../translate/i18n";

const TicketInfo = ({ contact, ticket, onClick }) => {
  const classes = useStyles();
	return (
		<CardHeader
			className={classes.info}
      onClick={onClick}
			style={{ cursor: "pointer" }}
			titleTypographyProps={{ noWrap: true }}
			subheaderTypographyProps={{ noWrap: true }}
			avatar={<Avatar src={contact.profilePicUrl} alt="contact_image" />}
			title={`${ticket.emailChannel ? "✉ " : ""}${contact.name} #${ticket.id}`}
			subheader={
				<span title={`Kanban: ${ticket.kanbanStage?.name || "Entrada"}`}>
          {`Kanban: ${ticket.kanbanStage?.name || "Entrada"}`}
          {ticket.user && <span className="assignedOperator">{` · ${i18n.t("messagesList.header.assignedTo")} ${ticket.user.name}`}</span>}
        </span>
			}
		/>
	);
};

export default TicketInfo;


